module.exports = __webpack_public_path__ + "img/waving_hand_emoji.163cc1f.png";